export default function Pagination({ page, total, limit, changePage }) {
  const pageCount = Math.ceil(total / limit);
  const delta = 2;
  const range = [];

  range.push(1);

  if (page - delta > 2) range.push('start-ellipsis');

  for (let i = Math.max(2, page - delta); i <= Math.min(pageCount - 1, page + delta); i++) {
    range.push(i);
  }

  if (page + delta < pageCount - 1) range.push('end-ellipsis');

  if (pageCount > 1) range.push(pageCount);

  return (
    <nav aria-label="Page navigation" className="mt-3 container" style={{ maxWidth: '900px' }}>
      <ul className="pagination justify-content-center">
        <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => changePage(page - 1)}>Anterior</button>
        </li>

        {range.map((item, idx) => (
          item === 'start-ellipsis' || item === 'end-ellipsis' ? (
            <li key={idx} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={idx} className={`page-item ${page === item ? 'active' : ''}`}>
              <button className="page-link" onClick={() => changePage(item)}>{item}</button>
            </li>
          )
        ))}

        <li className={`page-item ${page >= pageCount ? 'disabled' : ''}`}>
          <button className="page-link" onClick={() => changePage(page + 1)}>Próximo</button>
        </li>
      </ul>
    </nav>
  );
}